import Button from 'features/common/components/Button'
import FormField from './common/components/FormField'
import FormInput from './common/components/FormInput'
import FormStageContainer from './common/components/FormStageContainer'
import {useTranslation} from 'react-i18next'
import useSignin from 'features/unauthorized/components/AuthPage/common/hooks/useSignin'
import PasswordFormInput from './common/components/PasswordFormInput'
import {useTypedTranslation} from 'i18n'
import LanguageSelect from './common/components/LanguageSelect'

const Signin = ({onCancel}: {onCancel: () => void}) => {
    const {t} = useTranslation()
    const {t: typedT} = useTypedTranslation()
    const {data, errors, onChange, onSubmit, onSubmitError, loading} =
        useSignin()
    const onChangeInput =
        (prop: keyof typeof data) =>
        (e: React.ChangeEvent<HTMLInputElement>) => {
            onChange({prop, value: e.target.value.toString()})
        }

    const noErrors = Object.keys(errors).length === 0
    const noEmptyFields = !!(data.email && data.password)

    const disableSubmit = !(noErrors && noEmptyFields)
    return (
        <FormStageContainer title="Sign in">
            <div className="flex flex-1 flex-col items-center gap-16">
                <form
                    className="flex w-[18.5rem] flex-col items-stretch gap-6 pt-20 xs:w-[21rem] xs:gap-12"
                    onSubmit={(e) => e.preventDefault()}
                >
                    <div className="flex min-w-0 flex-col items-stretch gap-6 text-sm">
                        <FormField title={t('AUTH_EMAIL')}>
                            <FormInput
                                value={data.email}
                                onChange={onChangeInput('email')}
                                error={errors.email}
                                placeholder={t('AUTH_EMAIL_PLACEHOLDER')}
                                type="email"
                                name="email"
                                autoComplete="email"
                            />
                        </FormField>
                        <FormField title={t('AUTH_PASSWORD')}>
                            <PasswordFormInput
                                value={data.password}
                                onChange={onChangeInput('password')}
                                error={errors.password}
                                placeholder={t(
                                    'AUTH_SIGNIN_PASSWORD_PLACEHOLDER',
                                )}
                                type="password"
                                name="current-password"
                                autoComplete="current-password"
                            />
                        </FormField>
                    </div>
                    <div className="flex justify-end">
                        <button
                            className="border-none bg-white text-sm font-bold text-yellow-40 underline underline-offset-2"
                            type="button"
                        >
                            {t('AUTH_FORGOT_PASSWORD')}
                        </button>
                    </div>
                    {onSubmitError && (
                        <div className="pl-4 text-xs text-red-700">
                            {typedT(onSubmitError.message)}
                        </div>
                    )}
                    <div className="flex justify-center gap-6">
                        <Button
                            onClick={onCancel}
                            view={'alt'}
                            className="h-9 rounded-full text-sm"
                            type="reset"
                        >
                            {t('AUTH_CANCEL_BUTTON')}
                        </Button>
                        <Button
                            disabled={disableSubmit}
                            className="h-9 rounded-full text-sm"
                            onClick={onSubmit}
                            isLoading={loading}
                            type="submit"
                        >
                            {t('AUTH_SIGNIN_BUTTON')}
                        </Button>
                    </div>
                </form>
                <LanguageSelect />
            </div>
        </FormStageContainer>
    )
}

export default Signin
